import React from 'react'
import { Skeleton } from '@mui/material'

import { TitleWithPopover, AppTableSeeker } from '@components'
import customerColumn from '../SkuGroupTable/columns/customer'
import useSkuGroupUserTableFilters from './@hooks/useFilters'
import userColumn from './columns/user'
import groupsColumn from './columns/groups'


export default function SkuGroupUserTable() {
    const { data, isLoading } = useSkuGroupUserTableFilters()

    if (isLoading) return <Skeleton variant="rectangular" height={400} />
    if (!data.length) return <></>

    const columns = [
        userColumn(),
        customerColumn(),
        groupsColumn(),
    ]

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title="Users & SKU Groups" />}
        columns={columns}
        options={{ viewColumns: false }}
    />
}
